import { useCallback } from "react";
import { UrlForwardsApi, useAPIAction } from "melco-shared-logic";

export const useDeleteForwards = () => {
  const [deleteForwards] = useAPIAction(
    UrlForwardsApi,
    async (api, id: string) => {
      await api.urlForwardsDelete({ id });

      return {
        successMessages: [{ message: "default" }],
        // data,
      };
    },
    {
      translationPrefix: "url_forward.actions.delete",
    }
  );

  return useCallback(
    async (forwardIds: string[]) => {
      const successfullyDeleted: string[] = [];

      for (const forwardId of forwardIds) {
        try {
          await deleteForwards(forwardId);
          successfullyDeleted.push(forwardId);
        } catch (e) {
          // error handling is already done in useAPIAction
        }
      }

      return successfullyDeleted;
    },
    [deleteForwards]
  );
};
